import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { FormGroup } from '@angular/forms'

@Component({
    selector: 'field-error-component',
    templateUrl: './field-error.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FieldErrorComponent {
  @Input() field: string;
  @Input() label: string;
  @Input() formGroup: FormGroup;

  isFieldValid() {
    return (
      this.formGroup.get(this.field).invalid &&
      this.formGroup.get(this.field).touched
    );
  }

  displayFieldCss() {
    return {
      'is-invalid': this.isFieldValid(),
    };
  }

  isFieldInvalidAndDirtyAndTouched() {
    return (
      this.formGroup.get(this.field).invalid &&
      (this.formGroup.get(this.field).dirty ||
        this.formGroup.get(this.field).touched)
    );
  }

  isFieldErrorsRequired() {
    return this.formGroup.get(this.field).errors['required'];
  }

  isFieldErrorsMin() {
    return (
      this.formGroup.get(this.field).errors['min'] ||
      this.formGroup.get(this.field).errors['minlength']
    );
  }

  isFieldErrorsMax() {
    return (
      this.formGroup.get(this.field).errors['max'] ||
      this.formGroup.get(this.field).errors['maxlength']
    );
  }

  isFieldErrorsPattern() {
    return this.formGroup.get(this.field).errors['pattern'];
  }

  isFieldErrorsPreviousDate() {
    return this.formGroup.get(this.field).errors['invalidPreviousDate'];
  }

  isFieldErrorsFutureDate() {
    return this.formGroup.get(this.field).errors['invalidFutureDate'];
  }

  isFieldErrors18YearOldDate() {
    return this.formGroup.get(this.field).errors['invalid18YearsOldDate'];
  }

  isFieldErrorsEmail() {
    return this.formGroup.get(this.field).errors['email'];
  }

  isFieldErrorsCpf() {
    const errors = this.formGroup.get(this.field).errors;
    return !!(errors && (errors['cpfNotValid'] || errors['cpfInvalid']));
  }

  isFieldErrorsCnpj() {
    const errors = this.formGroup.get(this.field).errors;
    return !!(errors && errors['cnpjInvalid']);
  }

  isFieldErrorsRequest() {
    return this.formGroup.get(this.field).errors['requestWrongFormat'];
  }

  isFieldErrorsMustMatch() {
    const control = this.formGroup.get(this.field);
    const newPasswordControl = this.formGroup.get('newPassword');

    if (!control || !newPasswordControl) return false;

    const hasOtherErrors = control.errors && (
      control.errors['required'] ||
      control.errors['minlength'] ||
      control.errors['maxlength'] ||
      control.errors['pattern']
    );

    if (hasOtherErrors) return false;

    return control.value && newPasswordControl.value && control.value !== newPasswordControl.value;
  }

  isMatDatepickerParse() {
    return this.formGroup.get(this.field).errors['matDatepickerParse'];
  }
}
